<!-- Dialog: ADD FILL COMMENT -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="false"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>
  <div class="dialog__body__trade-add-fill-comment">
    <p class="trade__dialog__fill-comment__content-details">{{ data.dialogData.message_text }}</p>

    <textarea
      pInputTextarea
      class="trade__dialog__fill-comment__content-comment"
      [(ngModel)]="data.dialogData.comment"
      maxlength="250"
      rows="4"
      cols="62"
      autoResize="false"
      placeholder="{{data.dialogData.placeholder}}"
    ></textarea>
    <bfx-comment-warning></bfx-comment-warning>
  </div>
  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionAddFillComment_cancel()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionAddFillComment_submit()"
      label="Add"
      [disabled]="!data.dialogData.comment ||
										data.dialogData.comment.length < 1 ||
										data.dialogData.comment.length > 250"
    ></button>
  </p-footer>
</p-dialog>
